import { useMemo, useRef } from 'preact/hooks';

/**
 * A debounced version of `fn` that always calls the latest `fn` reference (safe to pass an
 * inline arrow function from the caller on every render — only `delay` needs to be stable).
 */
export function useDebouncedCallback(
  fn: (value: number) => void,
  delay: number,
): (value: number) => void {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  return useMemo(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    return (value: number) => {
      if (timer !== undefined) clearTimeout(timer);
      timer = setTimeout(() => fnRef.current(value), delay);
    };
  }, [delay]);
}
